import React from 'react';
import PreviousTournamentList from '../components/PreviousTournamentList';

const PreviousTournamentPage = () => {
    
        return (
            <div data-testid="previousEventPage">
              <PreviousTournamentList />
            </div>
          );
    }


export default PreviousTournamentPage;